import { RouteComponentProps, withRouter } from 'react-router';
import { styled } from '@mui/material/styles';
import CompanyReportWithMenus from 'kosmos/components/combinedCompanyReport/CompanyReportWithMenus';
import { GetSgReportById } from 'services/kosmosReport';

const PREFIX = 'TfpCombinedCompanyReportPage';

const classes = {
  tabHeaders: `${PREFIX}-tabHeaders`,
  tabRoot: `${PREFIX}-tabRoot`,
  tabSelected: `${PREFIX}-tabSelected`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.tabHeaders}`]: {},
  [`& .${classes.tabRoot}`]: {
    height: 70,
    fontSize: 20,
  },
  [`& .${classes.tabSelected}`]: {
    fontWeight: 'bold',
  },
}));

function TfpCombinedCompanyReportPage(props: RouteComponentProps<{ id: string }>): JSX.Element {
  const id = props.match.params.id;
  const query = new URLSearchParams(props.location.search);
  const orgId = query.get('organisationId') || undefined;

  const handleFetch = async (id: string) => {
    const reports = await GetSgReportById(id, orgId);
    return reports;
  };

  if (!id) {
    return <></>;
  }
  return (
    <Root>
      <CompanyReportWithMenus id={id} organisationId={orgId} onFetchReport={handleFetch} />
    </Root>
  );
}

export default withRouter(TfpCombinedCompanyReportPage);
